<template>
	<div>
		<div class="text-center">
			<div class="text-right">
				<small>
					جهت فیلتر کردن طرح های متناسب با شراط خود بر روی لینک زیر بزنید:
				</small>
			</div>
			<v-btn small text color="info" class="" @click="dialogSelector = true">تعیین شرایط</v-btn>
		</div>
		<v-card v-if="searchSubmitted" class="mt-2 pa-1" color="#ffedd2" elevation="0">
			<div class="d-flex">
				<v-icon small color="success" class="ml-1">mdi-check</v-icon>
				<div class="d-flex">
					<small class="">
						طرح های زیر بر اساس شرایط شما پیشنهاد شده است.
					</small>
					<v-btn small text color="red" class="mr-1" @click="() => { searchSubmitted = false; $emit('callback', null) }">
						<v-icon x-small color="red" class="ml-1">mdi-close</v-icon>
						<small>حذف فیلتر</small>
					</v-btn>
				</div>
			</div>
		</v-card>

		<v-dialog v-model="dialogSelector" scrollable persistent max-width="750px">
			<v-card>
				<v-card-title>
					<div><span class="headline">شرایط خود را اعلام کنید</span></div>
					<v-spacer />
					<v-btn @click="dialogSelector = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="12" class="d-flex justify-center">
								<v-img src="/hedef.jpg" height="100%" max-width="250" class="rounded-lg" contain></v-img>
							</v-col>
							<v-col cols="12" sm="12">
								<p class="text-justify grey--text fs-h5" style="">
									کاربر گرامی، «مشاور هوشمند» ما همراه شماست تا در کوتاه‌ترین زمان، بهترین طرح‌های تسهیلاتی متناسب با شرایطتان را پیدا کنید. کافیست شرایط خود را در فرم زیر وارد کرده و دکمه «ثبت شرایط» را بزنید؛ بقیه مسیر را به ما بسپارید تا مناسب‌ترین گزینه‌ها را پیش رویتان قرار دهیم.
								</p>
								<v-alert type="warning" outlined dense v-if="!ass_requirements.length">
									متاسفانه به دلیل عدم تنظیمات سیستم در حال حاضر این امکان در دسترس نمی باشد.
								</v-alert>
								<div v-else>
									<div class="text-center">
										<v-row class="">
											<v-col cols="12" md="4" v-for="(ass, index) in ass_requirements" :key="ass.id" class="">
												<div>{{ ass.title }}:</div>
												<v-select v-model="assuranceRequirementItemIds[ass.id]" clearable :items="ass.assuranceRequirementItems" item-text="title" item-value="id" dense outlined></v-select>
											</v-col>
										</v-row>
									</div>
									<div class="text-center mt-6">
										<v-btn class="rounded-xl" color="primary" @click="doSearch()" :loading="searchLoading">
											ثبت شرایط
										</v-btn>
									</div>
								</div>
							</v-col>
							<!-- Image Section -->

							<!-- Form Section -->
						</v-row>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'AssuranceRequirementSuggestionSelector',
		components: {
		},
		props: {
			customerCode: { type: Number },
		},
		data: () => ({
			errorMessage: '',
			submitLoading: false,
			message: '',
			searchSubmitted: false,
			assuranceRequirementItemIds: [],
			ass_requirements: [],
			searchLoading: false,
			dialogSelector: false,
		}),
		mounted() {
			this.getAssuranceRequirements()
		},
		computed: {
		},
		methods: {
			getAssuranceRequirements() {
				api.get('assuranceRequirement/List/' + this.customerCode, null, { authHeader: false, contentType: 'application/json' })
					.then(res => {
						this.ass_requirements = res
					}).catch(err => {
						toast.error('خطا در دریافت لیست شرایط متقاضی از سرور')
					})
			},
			doSearch() {
				this.searchSubmitted = false
				this.searchLoading = true
				const payload = {}
				for (const key in this.assuranceRequirementItemIds) {
					payload[key] = this.assuranceRequirementItemIds[key] === "" ? null : this.assuranceRequirementItemIds[key]
				}
				api.post('loan/ListByAssuranceRequirement/' + this.customerCode + '/true', payload, null, { authHeader: false, contentType: 'application/json' })
					.then(
						response => {
							this.searchSubmitted = true
							this.$emit('callback', response)
							this.dialogSelector = false
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.searchLoading = false
					})
			},
		},
	}
</script>

<style lang="scss"></style>